import { Component, OnInit } from '@angular/core';
import { GetTransactionReceiptFile } from '@app/finxone-web-frontend/app/lib/actions/transactions.action';
import { CountriesCurrenciesService } from '@app/finxone-web-frontend/app/lib/services/countries-currencies-service/countries-currencies.service';
import { TransactionState } from '@app/finxone-web-frontend/app/lib/state/transaction.state';
import {
  buildHandleBarModel,
  filterIfHandlebarNotRendered,
} from '@app/finxone-web-frontend/app/lib/utils/template/model-builder.utils';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { IconCacheService } from '@finxone-platform/shared/services';
import {
  DocumentActionType,
  FileExt,
  ProviderClass,
  cssToNgStyle,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import Handlebars from 'handlebars';
import { Subject, takeUntil } from 'rxjs';
import { SafeHtmlPipe } from '../../../../lib/pipes/SafeHtml.pipe';
import { PageConfigurationProvider } from '../../../zones/page-configuration.provider';
import { ImageWidgetComponent } from '../image-widget/image-widget.component';

@Component({
  selector: 'finxone-web-frontend-display-document-widget',
  templateUrl: './display-document-widget.component.html',
  imports: [SafeHtmlPipe, ImageWidgetComponent],
})
export class DisplayDocumentWidgetComponent implements OnInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  public imgPath = '';
  public documentActionType: DocumentActionType;
  public outerCssConfig: { [key: string]: string };
  public isFetching = true;
  public noDocumentAvailable = false;
  public noDocumentTemplateFunction: HandlebarsTemplateDelegate<any>;
  public fetchingTemplateFunction: HandlebarsTemplateDelegate<any>;
  public fetchingTemplate = '';
  public noDocumentTemplate = '';
  public showImageViewer: boolean;
  public showExpandDocument = true;

  constructor(
    private store: Store,
    public dataIn: ProviderClass<any>,
    private countriesCurrenciesService: CountriesCurrenciesService,
    public pageConfig: PageConfigurationProvider,
    private iconCacheService: IconCacheService,
  ) {}

  ngOnInit() {
    this.loadWidgetConfig();
    this.getImagePath();
  }

  private loadWidgetConfig() {
    this.outerCssConfig = cssToNgStyle(this.dataIn?.attri?.widgetProperties?.['outerCss'] ?? `height:40vh;`);
    this.showExpandDocument = this.dataIn?.attri?.widgetProperties?.['showExpandDocument'] ?? true;

    this.noDocumentTemplateFunction = Handlebars.compile(
      this.dataIn?.attri?.widgetProperties?.['noDocumentTemplate'] ?? '',
    );
    this.fetchingTemplateFunction = Handlebars.compile(
      this.dataIn?.attri?.widgetProperties?.['fetchingTemplate'] ?? '',
    );

    buildHandleBarModel(
      this.store,
      '',
      this.countriesCurrenciesService,
      this.iconCacheService,
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe((model) => {
        this.noDocumentTemplate = filterIfHandlebarNotRendered(this.noDocumentTemplateFunction(model));
        this.fetchingTemplate = filterIfHandlebarNotRendered(this.fetchingTemplateFunction(model));
      });
  }

  private getImagePath() {
    this.documentActionType = this.dataIn?.attri?.widgetProperties?.['documentActionType'];
    switch (this.documentActionType) {
      case DocumentActionType.TRANSACTIONS:
        this.getTransactionReceiptImage();
        break;

      default:
        break;
    }
  }

  private getTransactionReceiptImage() {
    const currentTransactionData = this.store.selectSnapshot(TransactionState.getTransactions);
    this.store.dispatch(
      new GetTransactionReceiptFile(
        DocumentActionType.TRANSACTIONS,
        currentTransactionData.currentTransactionId,
        'display',
      ),
    );
    const data = this.store.select(TransactionState.getTransactions);
    data.subscribe({
      next: (res) => {
        this.isFetching = res?.isDocumentDisplayDownloading ?? this.isFetching;
        this.imgPath = res?.transactionReceiptBlobUrl ?? '';
        const fileExtension = this.imgPath.split('.').pop() as FileExt;
        const imageFileType = [
          FileExt.JPEG,
          FileExt.JPG,
          FileExt.SVG,
          FileExt.PNG,
          FileExt.GIF,
          FileExt.WEBP,
        ];
        if (fileExtension) {
          this.showImageViewer = imageFileType.includes(fileExtension);
        }
      },
    });
  }
}
